"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockRefundsOverBalanceForOrganizationCountry = void 0;
const country_1 = require("../enums/country");
const blockRefundsOverBalanceForOrganizationCountry = (country) => {
    if (!country) {
        return false;
    }
    return country !== country_1.OrganizationCountry.UnitedStates && country !== country_1.OrganizationCountry.Canada;
};
exports.blockRefundsOverBalanceForOrganizationCountry = blockRefundsOverBalanceForOrganizationCountry;
